import { createStore, applyMiddleware, combineReducers, compose } from 'redux';
import { reducer as formReducer } from 'redux-form';
import { enableBatching } from 'redux-batched-actions';
import promiseMiddleware from 'redux-promise-middleware';
import replayMiddleware from 'redux-action-replay-middleware';

import reducers from './ducks';
import { createReducerAndMiddleware } from '../navigation/react-redux-nav';

export default function createStoreByApp(navigationMiddleware, initialState = {}) {
  const { navReducer, navMiddleware } = createReducerAndMiddleware(navigationMiddleware);
  const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

  return createStore(
    enableBatching(combineReducers({ ...reducers, ...navReducer, form: formReducer })),
    initialState,
    composeEnhancers(applyMiddleware(navMiddleware, promiseMiddleware(), replayMiddleware()))
  );
}
